import PopupMarketingPromo from './PopupMarketingPromo'

export default PopupMarketingPromo
// eslint-disable-next-line import/export
export * from './PopupMarketingPromo'
